import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as H, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, f = { key: 2 }, k = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconCaretLineUp"
}, L = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      H(p.$slots, "default"),
      e(n) === "bold" ? (l(), o("g", Z, t[0] || (t[0] = [
        a("path", { d: "M216.49,183.51a12,12,0,0,1-17,17L128,129,56.49,200.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0ZM48,84H208a12,12,0,0,0,0-24H48a12,12,0,0,0,0,24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (l(), o("g", m, t[1] || (t[1] = [
        a("path", {
          d: "M208,192H48l80-80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M133.66,106.34a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,200H208a8,8,0,0,0,5.66-13.66ZM67.31,184,128,123.31,188.69,184ZM40,72a8,8,0,0,1,8-8H208a8,8,0,0,1,0,16H48A8,8,0,0,1,40,72Z" }, null, -1)
      ]))) : e(n) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        a("path", { d: "M213.66,186.34A8,8,0,0,1,208,200H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0ZM48,80H208a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (l(), o("g", k, t[3] || (t[3] = [
        a("path", { d: "M212.24,196.24a6,6,0,0,1-8.48,0L128,120.49,52.24,196.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,196.24ZM48,78H208a6,6,0,0,0,0-12H48a6,6,0,0,0,0,12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (l(), o("g", h, t[4] || (t[4] = [
        a("path", { d: "M213.66,197.66a8,8,0,0,1-11.32,0L128,123.31,53.66,197.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,197.66ZM48,80H208a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (l(), o("g", w, t[5] || (t[5] = [
        a("path", { d: "M210.83,194.83a4,4,0,0,1-5.66,0L128,117.66,50.83,194.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,194.83ZM48,76H208a4,4,0,0,0,0-8H48a4,4,0,0,0,0,8Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
